import React from 'react';
import { ValueResource } from 'models/QuestionnaireResource';
import { QuestionRadio } from './QuestionRadio';
import { QuestionSlider } from './QuestionSlider';

export interface AnswerFieldProps {
	currentValue: number | undefined;
	answerValue: ValueResource;
	valueChanged?: (newValue: number) => void;
	disabled?: boolean;
	title?: string;
	idPrefix: string;
}

export const QuestionField = (props: AnswerFieldProps) => {
	
	switch (props.answerValue.type) {
		case 'radio':
			return <QuestionRadio {...props} />
		case 'slider':
			return <QuestionSlider {...props} />
	}
}
